import axiosInstance from "./axiosInstance";

export const fetchGetMonths = async () => {
  try {
    const response = await axiosInstance.get("/GetMonths");
    return response.data;
  } catch (error) {
    console.error("Error fetching months:", error);
    throw error;
  }
};



export const fetchGetYears = async () => {
  try {
    const response = await axiosInstance.get("/GetYears");
    return response.data;
  } catch (error) {
    console.error("Error fetching years:", error);
    throw error;
  }
};
